import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import EditPromoCode from './EditPromoCode';
import messages from '../../../../locale/jsonMessages';

export default async function action({ store, intl, params }) {

    const title = intl?.formatMessage(messages.editCouponCode)

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/promo-code', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {

        title,
        component: <AdminLayout>
            <EditPromoCode title={title} id={params?.id} />
        </AdminLayout>,
    };

}
